import { render, staticRenderFns } from "./addgoodssale.vue?vue&type=template&id=5141f3a8&scoped=true&"
import script from "./addgoodssale.vue?vue&type=script&lang=js&"
export * from "./addgoodssale.vue?vue&type=script&lang=js&"
import style0 from "./addgoodssale.vue?vue&type=style&index=0&id=5141f3a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141f3a8",
  null
  
)

export default component.exports